export default "__VITE_ASSET__BrnNYb8t__"